import React, { useContext } from "react";
import { AssessmentProfilesStyles } from './Style'
import { AssessmentsContext } from "./AssessmentsContext";
import { ratingKeys } from "keys/rating";
import ProfileCard from "./ProfileCard";

const AbilityCards = () => {
    const { abilities } = useContext(AssessmentsContext)

    const abilitiesData = abilities.data?.data

    return (
        <AssessmentProfilesStyles>
            {abilitiesData &&
                <div className="profile-cards">
                    {Object.keys(abilitiesData).map((ablilityKey, profileGroupIndex) => {
                        return (
                            <div className="profile-item">
                                <div className="profile-item-name bold">
                                    {ratingKeys[ablilityKey]}
                                </div>
                                <div className="profile-items">
                                    {Object.keys(abilitiesData?.[ablilityKey])?.map((profileKey, index) => {
                                        return (
                                            <ProfileCard
                                                ratingKey={ablilityKey}
                                                ratingIndex={index + 1}
                                                profile={{ test_takers: abilitiesData[ablilityKey][profileKey] }}
                                                index={profileGroupIndex * 3 + index} />
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>}
        </AssessmentProfilesStyles>
    )
}

export default AbilityCards